import { render, staticRenderFns } from "./UIkit.vue?vue&type=template&id=f23b2356&"
import script from "./UIkit.vue?vue&type=script&lang=js&"
export * from "./UIkit.vue?vue&type=script&lang=js&"
import style0 from "./UIkit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports